<template>
  <div>
    会員ステータス状況
    <el-form :model="form" inline>
      <el-switch
        v-model="form.multiple"
        active-text="範囲指定"
        inactive-text="単月指定" />
      <el-date-picker
        v-model="form.targetMonth"
        :clearable="false"
        type="month">
      </el-date-picker>
      <div style="display: inline;" v-show="form.multiple"> 〜
        <el-date-picker
          v-model="form.toTargetMonth"
          :clearable="false"
          type="month">
        </el-date-picker>
      </div>
      <el-select v-model="form.shop">
        <el-option
          v-if="groupPk"
          label="全店舗"
          :value="groupPk" />
        <el-option
          v-for="shop in shops"
          :key="shop.pk"
          :label="shop.name"
          :value="shop.pk">
        </el-option>
      </el-select>
      <el-button
        type="primary"
        :disabled="!form.shop || isLoading"
        v-loading="isLoading"
        @click="fetchData(false)">表示</el-button>
      <el-tooltip content="時間がかかります．全店舗対象の再集計は非推奨です．">
        <el-button
          type="success"
          :disabled="!form.shop || isLoading"
          v-loading="isLoading"
          @click="fetchData(true)">再集計</el-button>
      </el-tooltip>
      <el-button
        :disabled="!items.length || isLoading"
        icon="el-icon-download"
        type="warning"
        @click="download">ダウンロード</el-button>
    </el-form>
    <el-form :model="narrowForm" style="margin-top: 20px;" inline>
      <el-checkbox v-model="narrowForm.showCount">数量を表示</el-checkbox>
      <el-checkbox v-model="narrowForm.showRate">割合を表示</el-checkbox>
      <el-radio-group v-model="narrowForm.calculateRate" size="mini">
        <el-radio-button label="total">全体の割合を表示</el-radio-button>
        <el-radio-button label="row">行の割合を表示</el-radio-button>
      </el-radio-group>
    </el-form>
    <div
      v-for="data in items"
      :key="data.id"
      class="data-area" style="margin-top: 20px;">
      集計対象: {{ data.date|printYear }}年{{ data.date|printMonth }}月
      <table border="1">
        <thead>
          <tr>
            <th>来店回数 ＼ 来店頻度</th>
            <th v-show="narrowForm.showCount">45日以内</th>
            <th v-show="narrowForm.showRate">45日以内(率)</th>
            <th v-show="narrowForm.showCount">90日以内</th>
            <th v-show="narrowForm.showRate">90日以内(率)</th>
            <th v-show="narrowForm.showCount">180日以内</th>
            <th v-show="narrowForm.showRate">180日以内(率)</th>
            <th v-show="narrowForm.showCount">181日以上経過</th>
            <th v-show="narrowForm.showRate">181日以上経過(率)</th>
            <th>合計</th>
            <th>合計(率)</th>
          </tr>
        </thead>
        <tr>
          <th>4回目以上</th>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.manyShortRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'manyShortRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.manyMiddleRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'manyMiddleRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.manyLongRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'manyLongRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.manyNoRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'manyNoRepeat')|printRate }}</td>
          <td class="table-data">{{ data.manyVisitor }}</td>
          <td class="table-data">{{ data.manyVisitorRate|printRate }}</td>
        </tr>
        <tr>
          <th>3回目</th>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.thirdShortRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'thirdShortRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.thirdMiddleRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'thirdMiddleRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.thirdLongRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'thirdLongRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.thirdNoRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'thirdNoRepeat')|printRate }}</td>
          <td class="table-data">{{ data.thirdVisitor }}</td>
          <td class="table-data">{{ data.thirdVisitorRate|printRate }}</td>
        </tr>
        <tr>
          <th>2回目</th>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.secondShortRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'secondShortRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.secondMiddleRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'secondMiddleRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.secondLongRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'secondLongRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.secondNoRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'secondNoRepeat')|printRate }}</td>
          <td class="table-data">{{ data.secondVisitor }}</td>
          <td class="table-data">{{ data.secondVisitorRate|printRate }}</td>
        </tr>
        <tr>
          <th>1回目</th>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.firstShortRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'firstShortRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.firstMiddleRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'firstMiddleRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.firstLongRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'firstLongRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.firstNoRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'firstNoRepeat')|printRate }}</td>
          <td class="table-data">{{ data.firstVisitor }}</td>
          <td class="table-data">{{ data.firstVisitorRate|printRate }}</td>
        </tr>
        <tr>
          <th>総計</th>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.shortRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'shortRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.middleRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'middleRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.longRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'longRepeat')|printRate }}</td>
          <td class="table-data" v-show="narrowForm.showCount">{{ data.noRepeat }}</td>
          <td class="table-data" v-show="narrowForm.showRate">{{ getRate(data, 'noRepeat')|printRate }}</td>
          <td class="table-data">{{ data.totalCount }}</td>
          <td class="table-data">-</td>
        </tr>
      </table>
      最終集計日時: {{ data.updatedAt|printDateTime }}
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import ShopType from '@/consts/ShopType'
import downloadCsv from '@/misc/downloadCsv'

export default {
  name: 'AnalyticsCustomerStatus',
  filters: {
    printDate (val) {
      return moment(val).locale('ja').format('D (ddd)')
    },
    printRate (val) {
      let value = Math.round(val * 1000)
      if (value % 10 === 0) {
        value = (value / 10) + '.0%'
      } else {
        value = (value / 10) + '%'
      }
      return value
    },
    printYear (val) {
      if (!val) {
        return '-'
      }
      return moment(val).locale('ja').format('YYYY')
    },
    printMonth (val) {
      if (!val) {
        return '-'
      }
      return moment(val).locale('ja').format('MM')
    },
    printDateTime (val) {
      if (!val) {
        return '-'
      }
      return moment(val).locale('ja').format('YYYY/MM/DD HH:mm:ss')
    },
  },
  data () {
    return {
      form: {
        targetMonth: null,
        toTargetMonth: null,
        multiple: false,
        shop: null,
      },
      narrowForm: {
        showRate: true,
        showCount: true,
        calculateRate: 'total',
      },
      fromDate: null,
      toDate: null,
      shop: null,
      isLoading: false,
      dataAreaHeight: 600,
      items: [],
      groupPk: null,
      shops: [],
    }
  },
  mounted () {
    this.form.targetMonth = moment().date(1)
    this.form.toTargetMonth = moment().date(1)
    this.fetchShops()
  },
  methods: {
    getRate (data, key) {
      if (this.narrowForm.calculateRate === 'total') {
        const val = data[key]
        return data.totalCount ? val / data.totalCount : 0
      } else {
        return data[`${key}Rate`]
      }
    },
    fetchData (recalculate = false) {
      if (!this.form.shop) {
        return
      }
      if (this.form.multiple && !this.form.toTargetMonth) {
        return
      }
      let from = moment(this.form.targetMonth)
      let to = this.form.multiple ? moment(this.form.toTargetMonth) : moment(this.form.targetMonth)

      if (from > to) {
        const tmp = from
        from = to
        to = tmp
      }
      this.fromDate = from.clone()
      this.toDate = to.clone()
      this.shop = this.form.shop

      const f = async function () {
        while (from.diff(to, 'days') <= 0) {
          const year = from.year()
          const month = from.month() + 1
          await this.$request.analytics.customerStatus(year, month, this.form.shop, recalculate).then(res => {
            this.items.push(res.body)
          })
          from = from.add(1, 'M')
        }
      }
      this.isLoading = true
      this.items = []
      f.bind(this)().then(() => {
        this.isLoading = false
      })
      /*
      let year = moment(this.form.targetMonth).year()
      let month = moment(this.form.targetMonth).month() + 1
      this.isLoading = true
      this.$request.analytics.customerStatus(year, month, this.form.shop, recalculate).then(res => {
        // this.data = res.body
        this.items.push(res.body)
        console.log(res.body)
      }).finally(() => {
        this.isLoading = false
      })
      */
    },
    download () {
      if (!this.items) {
        return
      }
      let filename = '会員ステータス'
      if (this.form.multiple) {
        filename += moment(this.fromDate).locale('ja').format('YYYY年MM月') + '-' + moment(this.toDate).locale('ja').format('YYYY年MM月')
      } else {
        filename += moment(this.fromDate).locale('ja').format('YYYY年MM月')
      }
      filename += '_' + moment().format('YYYYMMDDHHmmss') + '.csv'
      const header = [
        '店舗',
        '来店回数＼来店頻度',
        '45日以内',
        '45日以内(率)',
        '90日以内',
        '90日以内(率)',
        '180日以内',
        '180日以内(率)',
        '181日以上',
        '181日以上(率)',
        '合計',
        '合計(率)',
        '集計日',
        '対象日',
      ]
      let data = []
      this.items.forEach(x => {
        const shop = this.shops.find(x => x.pk === this.shop)
        const shopName = shop ? shop.name : '全店'
        data.push([
          shopName,
          '4回目以上',
          x.manyShortRepeat,
          this.getRate(x, 'manyShortRepeat'),
          x.manyMiddleRepeat,
          this.getRate(x, 'manyMiddleRepeat'),
          x.manyLongRepeat,
          this.getRate(x, 'manyLongRepeat'),
          x.manyNoRepeat,
          this.getRate(x, 'manyNoRepeat'),
          x.manyVisitor,
          x.manyVisitorRate,
          moment(x.updatedAt).locale('ja').format('YYYY/MM/DD'),
          moment(x.date).locale('ja').format('YYYY/MM/DD'),
        ])
        data.push([
          shopName,
          '3回目',
          x.thirdShortRepeat,
          this.getRate(x, 'thirdShortRepeat'),
          x.thirdMiddleRepeat,
          this.getRate(x, 'thirdMiddleRepeat'),
          x.thirdLongRepeat,
          this.getRate(x, 'thirdLongRepeat'),
          x.thirdNoRepeat,
          this.getRate(x, 'thirdNoRepeat'),
          x.thirdVisitor,
          x.thirdVisitorRate,
          moment(x.updatedAt).locale('ja').format('YYYY/MM/DD'),
          moment(x.date).locale('ja').format('YYYY/MM/DD'),
        ])
        data.push([
          shopName,
          '2回目',
          x.secondShortRepeat,
          this.getRate(x, 'secondShortRepeat'),
          x.secondMiddleRepeat,
          this.getRate(x, 'secondMiddleRepeat'),
          x.secondLongRepeat,
          this.getRate(x, 'secondLongRepeat'),
          x.secondNoRepeat,
          this.getRate(x, 'secondNoRepeat'),
          x.secondVisitor,
          x.secondVisitorRate,
          moment(x.updatedAt).locale('ja').format('YYYY/MM/DD'),
          moment(x.date).locale('ja').format('YYYY/MM/DD'),
        ])
        data.push([
          shopName,
          '1回目',
          x.firstShortRepeat,
          this.getRate(x, 'firstShortRepeat'),
          x.firstMiddleRepeat,
          this.getRate(x, 'firstMiddleRepeat'),
          x.firstLongRepeat,
          this.getRate(x, 'firstLongRepeat'),
          x.firstNoRepeat,
          this.getRate(x, 'firstNoRepeat'),
          x.firstVisitor,
          x.firstVisitorRate,
          moment(x.updatedAt).locale('ja').format('YYYY/MM/DD'),
          moment(x.date).locale('ja').format('YYYY/MM/DD'),
        ])
        data.push([
          shopName,
          '合計',
          x.shortRepeat,
          this.getRate(x, 'shortRepeat'),
          x.middleRepeat,
          this.getRate(x, 'middleRepeat'),
          x.longRepeat,
          this.getRate(x, 'longRepeat'),
          x.noRepeat,
          this.getRate(x, 'noRepeat'),
          x.totalCount,
          '-',
          moment(x.updatedAt).locale('ja').format('YYYY/MM/DD'),
          moment(x.date).locale('ja').format('YYYY/MM/DD'),
        ])
      })

      downloadCsv(filename, header, data, null)
    },
    fetchShops () {
      this.$request.shops.list().then(res => {
        this.shops = res.body.results.filter(obj => obj.shopType === ShopType.SHOP)
        this.groupPk = res.body.results.find(obj => obj.shopType === ShopType.GROUP).pk
      })
    },
  },
}
</script>

<style scoped>
.data-area {
  overflow: auto;
}

.table-data {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Analytics/CustomerStatus.vue